import { Pipe, PipeTransform } from '@angular/core';

@Pipe({standalone: true, name: 'sealines'})
export class SealinesPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case 1: return 'Первая';
            case 2: return 'Вторая';
            case 3: return 'Третья и дальше';
            default: return value.toString();
        }
    }
}
